<template>
  <div class="creation-dates-selection">
    <template v-if="!dates">
      <!-- if dates not set, display buttons -->
      <ExtraBtnSquare icon="fad fa-calendar-range" :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATES_SELECTION')" @click="$emit('selectDates')" />
    </template>
    <template v-if="dates">
      <!-- if dates are already set, display them -->
      <a @click="$emit('selectDates')">
        <IconBoxWrapper icon="icon-f-calendar" :hide-icon="hideIcon">
          <QInput
            class="creation-dates-selected"
            :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATE_START')"
            :model-value="startDateFormatted"
            borderless
            readonly
          />
          <QInput
            class="creation-dates-selected"
            :label="$t('ETAB.PAGES.DEMANDS.CREATION.@DATE_END')"
            :model-value="endDateFormatted"
            borderless
            readonly
          />
        </IconBoxWrapper>
      </a>
    </template>
  </div>
</template>

<script>
  import { DatesHelpers } from "@core/helpers";

  export default {
    props: {
      dates: {
        type: Object,
        default: () => ({}),
      },
      hideIcon: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["selectDates"],
    computed: {
      startDateFormatted() {
        return this.dates.start ? DatesHelpers.getDayjs(this.dates.start).format("L") : null;
      },
      endDateFormatted() {
        return this.dates.end ? DatesHelpers.getDayjs(this.dates.end).format("L") : null;
      },
    },
  };
</script>

<style lang="scss">
  .creation-dates-selection {
    display: flex;
    align-items: center;
    justify-content: center;

    > button {
      margin: 5px;
    }

    .creation-dates-selected {
      padding: 0px 15px;
    }
  }
</style>
